import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import Navbar from '../navbar/Navbar'

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import Footer from '../footer/footer'
import '../landing/landing.css'
import './Aboutus.css'
import GitHubIcon from '@material-ui/icons/GitHub';
import FacebookIcon from '@material-ui/icons/Facebook';



const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  large: {
    width: theme.spacing(22),
    height: theme.spacing(22),
  },
}));

export default function FullWidthGrid() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Navbar />
      <Link id='back' to="/">
                <Button style={{ margin: '10px',marginTop:'80px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
      <h1 id='meetteam' style={{ color: 'black', marginTop: '10px', textAlign: 'center', backgroundColor:'white' }}><u>MEET THE TEAM</u></h1> <br />
      <Grid id='aboutgrid' container spacing={1} justify='center' >


        <Grid item xs={6} sm={2}>
          <Paper  id='abouts'>
            <img id='about' src="https://viewnotes.netlify.com/img/ajmal.jpeg" alt=""/>
            <h3>Ajmal Shah</h3>
            <h5>Creator</h5>
            <a id='profile_icons' href="https://www.facebook.com/ajmal.shah079"><FacebookIcon /></a>
						{/* <a id='profile_icons' href="https://github.com/ajshah7"><GitHubIcon style={{color:'black'}}/></a> */}
          </Paper>
        </Grid>

        <Grid item xs={6} sm={2}>
          <Paper  id='abouts'>
            <img id='about' src="https://viewnotes.netlify.com/img/DM.jpeg" alt=""/>
            <h3>D.M Abhishek</h3>
            <h5>Co-Creator</h5>
            <a id='profile_icons' href="hhttps://www.facebook.com/abhishekdm"><FacebookIcon /></a>
						{/* <a id='profile_icons' href="https://github.com/Abhishekdm"><GitHubIcon style={{color:'black'}}/></a> */}
          </Paper>
        </Grid>

        <Grid item xs={6} sm={2}>
          <Paper  id='abouts'>
            <img id='about' src="https://viewnotes.netlify.com/img/aneesh.jpeg" alt=""/>
            <h3>Aneesh Rao</h3>
            <h5>Contributor</h5>
          </Paper>
        </Grid>

        <Grid item xs={6} sm={2}>
          <Paper  id='abouts'>
            <img id='about' src="https://viewnotes.netlify.com/img/Afnan.jpeg" alt=""/>
            <h3>Afnan Ahammed</h3>
            <h5>Contributor</h5>
          </Paper>
        </Grid>

      </Grid>
      <h3 style={{textAlign:'center'}}>Join us, be a Contributor! and help the student community</h3>
      <Divider/>
      <h5 style={{marginTop:'20px',textAlign:'center'}}>Read Tems and condition<a  href="https://drive.google.com/file/d/1KStJGb2bBzKUpenya5GzBweckFYcAheI/view?usp=sharing"> Click here</a></h5>
      <Divider/>
      <h3 style={{ textAlign: 'center', color: 'blue' }}>Engage with our services bellow.</h3>
      {/* <script src='../../commentFile.js'></script> */}

      <Footer />
    </div>
  );
}
